import { Button, ButtonProps, darken } from '@mui/material';
import React from 'react';

export default function RoundedSecondaryButton({ ...props }: ButtonProps) {
  return (
    <Button
      {...props}
      variant="contained"
      color="inherit"
      sx={{
        'borderRadius': 4,
        'fontSize': 16,
        'backgroundColor': '#F0EEF1',
        'boxShadow': 'none',

        '&:hover': {
          boxShadow: 'none',
          backgroundColor: darken('#F0EEF1', 0.1),
        },

        ...props.sx,
      }}
    ></Button>
  );
}
